import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INVALID_ID } from '../../global/constants/ap_id_constants';
import { IAPProgramInfoDatasource } from '../../global/datasources/ap_program_info_datasource';

interface IProgramInfo {
  id: number;
  planInstructions: string;
  planShortInstructions: string;
}
export class APProgramInfoQuery implements IQuery {
  private __result: IProgramInfo;

  constructor(QueryMediator: IQueryMediator, private ngAPProgramInfoDatasource: IAPProgramInfoDatasource) {
    QueryMediator.registerQuery(this, ngAPProgramInfoDatasource);
  }

  run(): this {
    const _programInfo = _4.first(this.ngAPProgramInfoDatasource.values());
    if (!_4.isEmpty(_programInfo)) {
      const {
        plan_instructions: planInstructions = '',
        id = INVALID_ID,
        short_plan_instructions: planShortInstructions = ''
      } = _programInfo;
      this.__result = {
        planInstructions,
        id,
        planShortInstructions
      };
    }
    return this;
  }

  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPProgramInfoQuery', APProgramInfoQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_program_info_query.ts